import { Stack } from "@mui/material";
import { FC } from "react";
import { ECompanyContractStatus } from "@/types/enum";
import { TopList } from "@/features/company/components/TopList";
import { CompanyListTable } from "@/features/company/components/CompanyListTable";

const contractStatuses = [ECompanyContractStatus.DURING_CONTRACT];

export const CompanyDuringContractList: FC = () => {
  return (
    <Stack gap={2}>
      <TopList contractStatuses={contractStatuses} />
      <CompanyListTable contractStatuses={contractStatuses} />
    </Stack>
  );
};
